import Single1 from "./1.jpg";
import Single2 from "./2.jpg";
import Single3 from "./3.jpg";
import Single4 from "./4.jpg";
import Single5 from "./5.jpg";
import Single6 from "./6.jpg";
import Single7 from "./7.jpg";
import Single8 from "./8.jpg";
import Single9 from "./9.jpg";
import Single10 from "./10.jpg";
import Single11 from "./11.jpg";
import Single12 from "./12.jpg";
import Single13 from "./13.jpg";
import Single14 from "./14.jpg";
import Single15 from "./15.jpg";
import Single16 from "./16.jpg";
import Single17 from "./17.jpg";
import Single18 from "./18.jpg";
import Single19 from "./19.jpg";
import Single20 from "./20.jpg";

export const photographyImages = [
    Single1,
    Single2,
    Single3,
    Single4,
    Single5,
    Single6,
    Single7,
    Single8,
    Single9,
    Single10,
    Single11,
    Single12,
    Single13,
    Single14,
    Single15,
    Single16,
    Single17,
    Single18,
    Single19,
    Single20
];